import { Inject, Injectable, OnDestroy } from '@angular/core';
import {
  MsalService,
  MsalBroadcastService,
  MSAL_GUARD_CONFIG,
  MsalGuardConfiguration
} from '@azure/msal-angular';
import {
  AccountInfo
} from '@azure/msal-browser';
import { Subject } from 'rxjs';
import { ConfigLoaderService } from './Config/config-loader.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService implements OnDestroy {
  isIframe = false;
  loginDisplay = false;
  private readonly _destroying$ = new Subject<void>();

  constructor(
    @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
    private authService: MsalService,
    private msalBroadcastService: MsalBroadcastService
  ) { }

  async initializeAuth() {
    this.isIframe = window !== window.parent && !window.opener;
    // Removing MSAL login pop up code as it already calling in app.component.ts file
    
    // await this.checkAndSetActiveAccount();
  }

  // checkAndSetActiveAccount(): void {

  //   let activeAccount = this.authService.instance.getActiveAccount();

  //   if (!activeAccount) {
  //     const accounts = this.authService.instance.getAllAccounts();
  //     if (accounts.length > 0) {
  //       this.authService.instance.setActiveAccount(accounts[0]);
  //     }
  //   }
  // }

  getAccount(): void {

    const accounts = this.authService.instance.getAllAccounts();

    if (!accounts || accounts.length === 0) {
      return;
    }
    if (accounts.length > 1) {
      console.warn('Multiple accounts detected.');
    }

    ConfigLoaderService.settings.AppSettings.userId =
      accounts[0].username.split('@')[0];
  }

  isLoggedIn(): boolean {
    return this.authService.instance.getAllAccounts().length > 0;
  }
  getActiveAccount(): AccountInfo | null {
    return this.authService.instance.getActiveAccount();
  }

  logout(): void {

    this.authService.instance.setActiveAccount(null);

    this.authService.logoutRedirect({
      postLogoutRedirectUri:
        ConfigLoaderService.settings.adalConfig.redirectUri
    });
  }

  ngOnDestroy(): void {
    this._destroying$.next();
    this._destroying$.complete();
  }
}